export const shopByPageSlugQuery = (slug: string, locale: string) => `
query ShopByPageSlugQuery {
  pages(filters: { slug: { eq: "${slug}" } }, locale: "${locale}") {
    slug
    components {
      ... on ComponentMainShop {
        __component: __typename
        maxProducts
        categories {
          documentId
          name
          slug
          products(pagination: { pageSize: 50 }) {
            documentId
            name
            slug
            createdAt
            price
            discount
            productType
            isPreOrderable
            inventoryType
            category {
              documentId
            }
            variants(pagination: { pageSize: 50 }) {
              amount
              label
              uuid
              weight
            }
            images {
              alternativeText
              width
              height
              formats
              url
            }
            deliveryDates {
              documentId
              date
              isActive
            }
          }
          image {
            alternativeText
            width
            height
            formats
            url
          }
        }
      }
    }
  }
}
`;
